<template>
    <v-dialog v-model="shows" v-bind="$attrs" content-class="rounded-lg">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card class="overflow-hidden">
            <v-toolbar>
                <v-spacer></v-spacer>
                <v-btn icon text class="v-size--xx-large rounded-0" @click.stop="close"><u-icon>close</u-icon></v-btn>
            </v-toolbar>
            <div class="px-20px pb-20px px-md-60px pt-md-12px pb-md-80px">
                <tit v-if="this.$slots['tit']" class="tit-wrap--xs text-center mb-20px mb-md-40px"><slot name="tit" /></tit>
                <slot />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import UIcon from "@/components/publish/styles/icons/u-icon.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";

export default {
    props: {},
    components: {
        UIcon,
        Tit,
    },
    data() {
        return {
            shows: false,
        };
    },
    mounted() {},
    methods: {
        close() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
